import { Box, Container, DialogTitle, Typography } from "@mui/material";
import React, { FormEvent } from "react";
import Button from "../../../ui/elements/buttons/Button";
import { AddressElement, CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import stripeWatermark from  "../../../assets/svgs/stripeWatermark.svg";
import { useUserContext } from "../../user/UserContext";

interface Card {
    id: number;
    brand: string;
    last4: string;
    exp_month: number;
    exp_year: number;
}

const ELEMENT_OPTIONS = {
  style: {
    base: {
      color: "#323232",
      backgroundColor: "#fff",
      iconColor: "#323232",
      fontFamily: "Arial, sans-serif",
      fontSmoothing: "antialiased",
      fontSize: "16px",
      "::placeholder": {
        color: "#aab7c4",
      },
    },
    invalid: {
      color: "#fa755a",
      iconColor: "#fa755a",
    },
  },
};

interface AddCardProps {
  handleAddCard: any
    setOpenAddDialog: any;
}

const AddCard: React.FC<AddCardProps> = ({ handleAddCard, setOpenAddDialog }) => {
  const stripe = useStripe();
  const elements = useElements();

  const {user}=useUserContext();

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    const cardElement = elements.getElement(CardElement);
    const addressElement = elements.getElement(AddressElement);

    if (!cardElement || !addressElement) {
      console.error("Stripe elements not found.");
      return;
    }

    const { value: addressValue } = await addressElement.getValue();
    if (
      !addressValue?.address?.line1 ||
      !addressValue?.address?.postal_code ||
      !addressValue?.address?.city ||
      !addressValue?.address?.country
    ) {
      
      return;
    }

    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: cardElement,
      billing_details: {
        address: {
          line1: addressValue?.address?.line1,
          line2: addressValue?.address?.line2,
          city: addressValue?.address?.city,
          state: addressValue?.address?.state,
          postal_code: addressValue?.address?.postal_code,
          country: addressValue?.address?.country,
        },
      },
    });

    if (error) {
      console.error(error);
    } else if (paymentMethod && paymentMethod.card) {
      handleAddCard(paymentMethod.id);
      setOpenAddDialog(false)
    }
  };

  const handleClose =()=>{
    setOpenAddDialog(false)
  }

  return (
    <Container sx={{p:2, minWidth:{xs:'', md:'600px'}}}>
      <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
          <DialogTitle>Add Card</DialogTitle>
          <Button background={'white'} color={'red'} onClick={handleClose}>
              <CloseRoundedIcon />
          </Button>
      </Box>
      <form onSubmit={handleSubmit}>
        <Box sx={{ mb: 4 }}>
          <Typography>Email: {user?.email}</Typography>
        </Box>
        <Box sx={{ mb: 4 }}>
          <AddressElement options={{ mode: "billing" }} />
        </Box>
        <Box sx={{ mb: 4 }}>
          <CardElement options={ELEMENT_OPTIONS} />
        </Box>
        <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
          <Button
            type="submit"
            color="white"
            disabled={!stripe}
            sx={{ mb: 3 }}
          >
            Save
          </Button>
          <img style={{opacity:'0.3'}} src={stripeWatermark} alt="stripe watermark"/>
        </Box>
      </form>
    </Container>
  );
};

export default AddCard;
